import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Input, Label, FormGroup, Button, Form } from 'reactstrap';
import { CoreClassroomAdminClassroom } from "../../../../models/CoreClassroomAdminClassroom";
import { EmptyRequestState, RequestState } from "../../../../models/RequestState";
import { RootState } from "../../../../store/store";
import { ClassroomUpdateOwner, ClearClassroomUpdateOwner } from "../../../../store/ClassroomAdmin/ClassroomToolsAction";
import Loading from "../../../misc/Loading";
import StatusCode from "../../../../util/StatusCode";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const ClassroomViewToolUpdateOwner = () => {
    const { t } = useTranslation(['common', "classroomAdmin"]);
    const dispatch = useDispatch();

    const [ownerId, setOwnerId] = useState<string>("");
    const [submitted, setSubmitted] = useState<boolean>(false);

    const updateOwnerClassroomState = useSelector<RootState, EmptyRequestState>(x => x.classroomTools.updateOwnerClassroom);
    const classroom = useSelector<RootState, RequestState<CoreClassroomAdminClassroom>>(x => x.classroomAdminClassroom.classroom);

    useEffect(() => {
        return () => {
            ClearClassroomUpdateOwner()(dispatch);
        };
    }, []);

    const updateOwner = (e: React.FormEvent<HTMLFormElement>) => {
        setSubmitted(true);
        e.preventDefault();
        if (classroom.code === StatusCode.COMPLETE && classroom.data && isValid) {
            ClassroomUpdateOwner(classroom.data.classroomId, ownerId)(dispatch);
        }
    }

    const updateOwnerId = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (submitted) {
            ClearClassroomUpdateOwner()(dispatch);
        }
        setOwnerId(e.target.value)
    }

    const isValid = ownerId.length > 5;

    const renderState = () => {
        if (updateOwnerClassroomState.code === StatusCode.PENDING) {
            return <Loading />;
        };
        if (updateOwnerClassroomState.code === StatusCode.COMPLETE) {
            return (<>
                <FontAwesomeIcon icon="check" color="green" style={{ marginRight: '5px' }} />
                {t(`tools.UPDATE_OWNER.success`, { ns: 'classroomAdmin' })}
            </>);
        };
        if (updateOwnerClassroomState.code === StatusCode.ERROR) {
            const errorData = updateOwnerClassroomState.error.response?.data as { title?: string; detail?: string } | undefined;
            const title = errorData?.title;
            const errorMessage = title ? t(`tools.errors.general.${title}`, { ns: 'classroomAdmin' }) : t(`error.somethingWentWrong`, { ns: 'common' });
            return (<>
                <FontAwesomeIcon icon="triangle-exclamation" color="red" style={{ marginRight: '5px' }} />
                {errorMessage}
            </>);
        };
    };

    return (<>
        <Form onSubmit={updateOwner}>
            <FormGroup>
                <Label for="ownerId">{t('tools.UPDATE_OWNER.ownerEmailAddress', { ns: 'classroomAdmin' })}</Label>
                <Input
                    type="text"
                    name="ownerId"
                    id="ownerId"
                    placeholder={t('tools.UPDATE_OWNER.ownerEmailAddress', { ns: 'classroomAdmin' })}
                    autoComplete="off"
                    value={ownerId}
                    onChange={(e) => updateOwnerId(e)}
                    disabled={submitted && updateOwnerClassroomState.code === StatusCode.COMPLETE}
                />
                <div className="flex align-items-center mt-3">
                    <Button style={{ marginRight: '15px' }} type="submit" disabled={!isValid}>{t('tools.UPDATE_OWNER.title', { ns: 'classroomAdmin' })}</Button>
                    {renderState()}
                </div>
            </FormGroup>
        </Form>
    </>);
}

export default ClassroomViewToolUpdateOwner;
